import React, { useState } from "react";

import MenuNav from "../../components/portfolio/menu-nav.component";
import HeroSection from "../../components/portfolio/hero-section.component";
import BioSection from "../../components/portfolio/bio-section.component";
import Divider from "../../components/portfolio/divider.component";
import ProjectsSection from "../../components/portfolio/projects-section.component";
import WorkSection from "../../components/portfolio/work-section.component";
import InterestsSection from "../../components/portfolio/interests-section.component";
import QASection from "../../components/portfolio/qa-section.component";
import PortfolioFooter from "../../components/portfolio/portfolio-footer.component";

import "./home.styles.css";
import Contact from "../contact/contact.component";
import RecentprojectComponent from "../../components/recentproject/recentproject.component";
import About from "../about/about.component";
import Navbar from "../../components/navbar/navbar.component";

const Home = () => {

  return (
    <div className="portfolio-page">
      <Navbar/>
      <HeroSection />
      <BioSection />
      <Divider />
      <RecentprojectComponent />
      <Divider />
      <InterestsSection />
      <Divider />
      <PortfolioFooter />
    </div>
  );
};

export default Home;